import React, { FocusEvent, FunctionComponent } from 'react';

import { FormControlElementProps } from '../Form.constants';
import DatePicker from '../../DatePicker/DatePicker';

type DateInputFieldProps = {
  control: FormControlElementProps;
  inputChangedHandler: (name: string, value: string) => void;
  type?: 'month' | 'date';
};

const DatePickerInputField: FunctionComponent<DateInputFieldProps> = ({
  control,
  inputChangedHandler,
  type = 'date',
}) => {
  const {
    id,
    error,
    fieldType,
    label,
    touched,
    valid,
    validations,
    value,
    customDateFormat,
    showTimeSelect,
    showTimeSelectOnly,
    timeIntervals,
    ...elementProps
  } = control;

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement> | FocusEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    inputChangedHandler(name, value);
  };

  const handleOnBlur = (event: FocusEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    inputChangedHandler(name, value);
  };

  return (
    <div key={`${fieldType}-${id}`} className="form-picker-wrapper">
      <DatePicker
        id={id}
        required={!!validations?.required}
        title={label}
        error={touched && !valid ? error : ''}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        value={value as string}
        type={type}
        customDateFormat={customDateFormat}
        showTimeSelect={showTimeSelect}
        showTimeSelectOnly={showTimeSelectOnly}
        timeIntervals={timeIntervals}
        {...elementProps}
      />
    </div>
  );
};

export default DatePickerInputField;
